import { render, staticRenderFns } from "./hrdBoard.vue?vue&type=template&id=13f92730&"
import script from "./hrdBoard.vue?vue&type=script&lang=js&"
export * from "./hrdBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports